import React, { useState } from 'react';

const Header = ({ scrollToSection, servicesRef, whatWeDoRef, contact, ach }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="bg-gradient-to-br from-yellow-200 via-yellow-300 to-yellow-100 shadow-md h-28 relative z-50">
      <nav className="mx-auto flex max-w-7xl items-center justify-between h-full p-6 lg:px-8" aria-label="Global">
        {/* Logo */}
        <div className="flex items-center lg:flex-1 h-full">
          <a href="#" className="-m-1.5 p-1.5">
            <span className="sr-only">Your Company</span>
            <div className="h-28 w-28 rounded-full overflow-hidden flex items-center justify-center bg-white">
              <img
                className="h-full w-full object-contain"
                src="/logo.jpg"
                alt="Company Logo"
              />
            </div>
          </a>
        </div>

        {/* Desktop Menu */}
        <div className="hidden lg:flex lg:gap-x-14 h-full items-center">
          <a href="#" onClick={() => scrollToSection(servicesRef)} className="text-xl font-semibold leading-7 text-black hover:bg-orange-500 hover:text-white transition-all duration-300 rounded-lg px-3 py-2">
            Services
          </a>
          <a href="#" onClick={() => scrollToSection(whatWeDoRef)} className="text-xl font-semibold leading-7 text-black hover:bg-orange-500 hover:text-white transition-colors duration-300 rounded-lg px-3 py-2">
            About
          </a>
          <a href="#" onClick={() => scrollToSection(contact)} className="text-xl font-semibold leading-7 text-black hover:bg-orange-500 hover:text-white transition-colors duration-300 rounded-lg px-3 py-2">
            Contact
          </a>
          <a href="#" onClick={() => scrollToSection(ach)} className="text-xl font-semibold leading-7 text-black hover:bg-orange-500 hover:text-white transition-colors duration-300 rounded-lg px-3 py-2">
            Achievements
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="flex lg:hidden h-full items-center">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={toggleMenu}
          >
            <span className="sr-only">Open main menu</span>
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="fixed inset-0 z-40 bg-black/50" onClick={toggleMenu}></div>
      )}

      {/* Mobile Menu Panel */}
      <div className={`fixed top-0 right-0 z-50 h-full w-3/4 bg-white p-6 transition-transform duration-300 ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex items-center justify-between mb-8">
          <a href="#" className="-m-1.5 p-1.5">
            <span className="sr-only">Your Company</span>
            <img className="h-10 w-auto" src="/logo.jpg" alt="Company Logo" />
          </a>
          <button type="button" onClick={toggleMenu} className="p-2.5 rounded-md text-gray-700">
            <span className="sr-only">Close menu</span>
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="space-y-6">
          <button onClick={() => { scrollToSection(servicesRef); toggleMenu(); }} className="block w-full text-left text-xl font-semibold px-3 py-2 hover:bg-orange-500 hover:text-white rounded-lg transition">
            Services
          </button>
          <button onClick={() => { scrollToSection(whatWeDoRef); toggleMenu(); }} className="block w-full text-left text-xl font-semibold px-3 py-2 hover:bg-orange-500 hover:text-white rounded-lg transition">
            About
          </button>
          <button onClick={() => { scrollToSection(contact); toggleMenu(); }} className="block w-full text-left text-xl font-semibold px-3 py-2 hover:bg-orange-500 hover:text-white rounded-lg transition">
            Contact
          </button>
          <button onClick={() => { scrollToSection(ach); toggleMenu(); }} className="block w-full text-left text-xl font-semibold px-3 py-2 hover:bg-orange-500 hover:text-white rounded-lg transition">
            Achievements
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
